import { render, staticRenderFns } from "./SkillsStructure.vue?vue&type=template&id=5d3f5f8c&"
import script from "./SkillsStructure.vue?vue&type=script&lang=js&"
export * from "./SkillsStructure.vue?vue&type=script&lang=js&"
import style0 from "./SkillsStructure.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports